<template>
  <div class="product-detail-floor-2-container" v-if="productCount">
    <div class="product-detail-floor-2-title">
      <div class="product-detail-floor-2-text">同类所有商品</div>
      <div class="product-detail-floor-2-txt"></div>
    </div>
    <div class="product-detail-floor-2-content">
      <div class="product-detail-left">
        <div class="product-detail-left-title">
          <div class="product-detail-left-title-name">商品选项</div>
          <div class="product-detail-left-title-tag" @click="handleClear">
            清除筛选
          </div>
        </div>
        <div class="product-detail-collapse">
          <div class="product-detail-attr-title">
            <el-collapse v-model="activeIndex" v-if="isClear">
              <el-collapse-item
                :title="item.attrName"
                :name="index"
                v-for="(item, index) in productDetail.attrArray"
              >
                <div
                  class="product-detail-attr-val"
                  v-if="moreFlag[index] && item.attrList.length > 4"
                >
                  <el-checkbox
                    @change="handleCheck(item, item1)"
                    v-for="(item1, index1) in item.attrList"
                    :key="index1"
                    v-if="index1 < 4"
                  >
                    <el-tooltip placement="top" :content="item1" effect="dark" :disabled="disabled">
                      <div
                        @mouseenter="showToolTips(item1)"
                        @mouseleave="hideToolTips"
                        class="ellipsis"
                      >
                        {{ item1 }}
                      </div>
                    </el-tooltip>
                  </el-checkbox>
                  <div class="product-detail-more" @click="handleMore(index)">
                    更多
                    <img class="up-arrow" src="~@/assets/img/product/up.png" />
                  </div>
                </div>
                <div
                  class="product-detail-attr-val"
                  v-if="!moreFlag[index] && item.attrList.length > 4"
                >
                  <el-checkbox
                    v-for="(item1, index1) in item.attrList"
                    @change="handleCheck(item, item1)"
                    :key="index1"
                  >
                    <el-tooltip placement="top" :content="item1" effect="dark" :disabled="disabled">
                      <div
                        @mouseenter="showToolTips(item1)"
                        @mouseleave="hideToolTips"
                        class="ellipsis"
                      >
                        {{ item1 }}
                      </div>
                    </el-tooltip>
                  </el-checkbox>
                  <div class="product-detail-less" @click="handleMore(index)">
                    收起
                    <img class="down-arrow" src="~@/assets/img/product/down.png" />
                  </div>
                </div>
                <div class="product-detail-attr-val" v-if="item.attrList.length <= 4">
                  <el-checkbox
                    v-for="(item1, index1) in item.attrList"
                    @change="handleCheck(item, item1)"
                    :key="index1"
                  >
                    <el-tooltip placement="top" :content="item1" effect="dark" :disabled="disabled">
                      <div
                        @mouseenter="showToolTips(item1)"
                        @mouseleave="hideToolTips"
                        class="ellipsis"
                      >
                        {{ item1 }}
                      </div>
                    </el-tooltip>
                  </el-checkbox>
                </div>
              </el-collapse-item>
            </el-collapse>
          </div>
        </div>
      </div>
      <div class="product-detail-right">
        <div class="product-detail-floor-2-table">
          <el-table
            width="100%"
            :data="dataList"
            :header-cell-style="{
              background: '#F5F5F5',
              color: '#333333',
              height: '40px',
            }"
          >
            <el-table-column prop="productInfo" label="商品信息" width="440" align="center">
              <template slot-scope="scope">
                <product-info-in-list
                  :key="scope.$index"
                  :info="scope.row"
                  :itemNum="(queryParams.pageNum - 1) * queryParams.pageSize + scope.$index + 1"
                ></product-info-in-list>
              </template>
            </el-table-column>
            <el-table-column prop="productInfo" label="发货时间" width="180" align="center">
              <template slot-scope="scope">
                <div
                  style="
                    font-size: 12px;
                    display: flex;
                    align-items: flex-start;
                  "
                >
                  {{ scope.row.delivertime + '天内发货' }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="unitvalue"
              label="单位"
              width="150"
              align="center"
            ></el-table-column>
            <el-table-column prop="price" label="含税单价(元)" width="200" align="center">
              <template slot-scope="scope">
                <div
                  style="font-size: 14px; font-weight: bold; color: #f0250f"
                  v-if="scope.row.price"
                >
                  ￥{{ scope.row.price.toFixed(2) }}
                </div>
                <div style="font-size: 14px; font-weight: bold; color: #f0250f" v-else>
                  面议
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="product-detail-floor-2-pagination" v-if="listFilterData.total">
          <!-- 分页插件 -->
          <div class="pager-wrap">
            <!-- <pager
              :page-index="queryParams.pageNum"
              :total="listFilterData.total"
              :page-size="queryParams.pageSize"
              @change="handleCurrentChange"
            ></pager> -->
            <el-pagination
              @current-change="handleCurrentChange"
              :pager-count="5"
              :page-sizes="[10, 20, 30]"
              layout="total, prev, pager, next, jumper"
              :current-page="queryParams.pageNum"
              :total="listFilterData.total"
              :page-size.sync="queryParams.pageSize"
              prev-text="上一页"
              next-text="下一页"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>
    <transition
      appear
      @before-appear="beforeEnter"
      @after-appear="afterEnter"
      v-for="(item, index) in showMoveDot"
      :key="index.id"
    >
      <div class="move_dot" ref="ball" v-show="item">
        <img :src="dropImage" alt="" />
      </div>
    </transition>
  </div>
</template>

<script>
import api from '@/modules/projectA/api/product';
import ProductInfoInList from './product-info-in-list';
export default {
  name: 'product-detail-floor-2',
  components: {
    ProductInfoInList,
  },
  props: {
    productDetail: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      loginStatus: false,
      activeIndex: [],
      moreFlag: [],
      queryParams: {
        searchtext: '',
        thirdcategory: '',
        attributesList: [],
        specificationsList: [],
        brandname: '',
        pageNum: 1,
        pageSize: 5,
        orderBy: null,
        ranking: null,
      },
      listFilterData: {
        total: 0,
      },
      searchText: '',
      attributesList: [],
      specificationsList: [],
      dataList: [],
      isClear: true,
      productCount: false,
      hoverCart: -1,
      hoverCollect: -1,
      userInfo: {},
      showMoveDot: [], //控制下落的小圆点显示隐藏
      elLeft: 0, //当前点击购物车按钮在网页中的绝对top值
      elTop: 0, //当前点击购物车按钮在网页中的绝对left值
      dropImage: '', // 小球图片
      disabled: true,
      dataEase: {},
    };
  },
  watch: {
    'productDetail.attrArray': {
      handler(oldValue, newValue) {
        if (newValue) {
          for (let i = 0; i < newValue.length; i++) {
            if (newValue[i].attrList) {
              this.moreFlag[i] = true;
            } else {
              this.moreFlag[i] = false;
            }
          }
          for (let i = 0; i < newValue.length; i++) {
            this.activeIndex.push(i);
          }
        } else {
          if (oldValue) {
            for (let i = 0; i < oldValue.length; i++) {
              if (oldValue[i].attrList && oldValue[i].attrList.length > 0) {
                this.moreFlag[i] = true;
              } else {
                this.moreFlag[i] = false;
              }
            }
            for (let i = 0; i < oldValue.length; i++) {
              this.activeIndex.push(i);
            }
          }
        }
      },
      immediate: true,
    },
  },
  created() {
    this.getProductList();
  },
  mounted() {
    this.userInfo = this.$store.state.userInfo;
    this.dataEase = JSON.parse(localStorage.getItem('dataE'));
    // this.hasSameProduct()
    this.getCategoryList();
  },
  methods: {
    handleCloseDialog() {
      this.loginStatus = false;
    },
    async getProductList() {
      let params = {
        attributesList: this.attributesList,
        specificationsList: this.specificationsList,
        searchtext: this.searchText,
        skuId: this.productDetail.skuId,
        pageNum: this.queryParams.pageNum,
        pageSize: this.queryParams.pageSize,
      };

      let res = await api.querySameTypeProduct(params);

      this.dataList = res.data.list;

      this.listFilterData.total = res.data.total;

      for (let i = 0; i < this.dataList.length; i++) {
        this.$set(this.dataList[i], 'quantity', 1);
      }

      //埋点数据做准备
      this.queryParams.time = new Date().getTime();
      this.queryParams.total = res.data.total;
      this.queryParams.randomId =
        this.queryParams.time.toString() + Math.floor(Math.random() * 1000000 + 1);
      params.time = this.queryParams.time;
      params.total = this.queryParams.total;
      params.randomId = this.queryParams.randomId;
      this.dataList = this.addQuantityItem(this.dataList, this.queryParams.randomId);
    },
    async getCategoryList() {
      let params = {
        attributesList: this.attributesList,
        specificationsList: this.specificationsList,
        searchtext: this.searchText,
        skuId: this.productDetail.skuId,
        pageNum: this.queryParams.pageNum,
        pageSize: this.queryParams.pageSize,
      };

      let res = await api.querySameTypeProduct(params);

      if (res.data.total == 1) {
        this.productCount = false;
      } else {
        this.productCount = true;
      }
      // this.$set(this.productDetail, 'dataList', res.data.list)
      //获取左侧规格属性列表
      this.$set(this.productDetail, 'attrArray', []);
      for (let i in res.data.attribute) {
        let obj = {};
        this.$set(obj, 'attrName', i);
        this.$set(obj, 'attrList', res.data.attribute[i]);
        this.$set(obj, 'flag', 1);
        this.productDetail.attrArray.push(obj);
      }
      for (let i in res.data.specification) {
        let obj = {};
        this.$set(obj, 'attrName', i);
        this.$set(obj, 'attrList', res.data.specification[i]);
        this.$set(obj, 'flag', 2);
        this.productDetail.attrArray.push(obj);
      }
    },
    //翻页
    handleCurrentChange(page) {
      this.queryParams.pageNum = page;
      this.getProductList();
    },
    handleSearch() {
      this.queryParams.pageNum = 1;
      this.getProductList();
    },
    handleClear() {
      this.isClear = false;
      // 在组件移除后，重新渲染组件
      // this.$nextTick可实现在DOM 状态更新后，执行传入的方法。
      this.$nextTick(() => {
        this.isClear = true;
      });
      this.specificationsList = [];
      this.attributesList = [];
      this.handleSearch();
    },
    handleCheck(item, item1) {
      let obj = item.attrName + '_' + item1;
      if (item.flag == 1) {
        if (this.attributesList.indexOf(obj) == -1) {
          this.attributesList.push(obj);
        } else {
          this.attributesList.splice(this.attributesList.indexOf(obj), 1);
        }
      } else {
        if (this.specificationsList.indexOf(obj) == -1) {
          this.specificationsList.push(obj);
        } else {
          this.specificationsList.splice(this.specificationsList.indexOf(obj), 1);
        }
      }

      this.handleSearch();
    },
    EditNum(val, id, isSelect, subtotal, checked, itemData) {},
    formatParams(productInfo, rateInfo) {
      let res = {};
      res.baseUnitName = productInfo.unitvalue;
      res.baseUnitNo = productInfo.unitid;
      res.brandName = productInfo.brandname;
      res.categoryId = productInfo.thirdcategorycode;
      res.categoryName = productInfo.thirdcategory;
      res.goodsUnitName = productInfo.unitvalue;
      res.goodsUnitNo = productInfo.unitid;
      res.inherentPropertyAOList = [];
      res.salesPropertyInfoAOList = [];
      (res.inherentPropertyAOList = productInfo.attributesList
        ? this.assembleCartParams(
            productInfo.attributesList,
            'inherentPropertyName',
            'inherentPropertyValue'
          )
        : []),
        (res.salesPropertyInfoAOList = productInfo.specificationsList
          ? this.assembleCartParams(
              productInfo.specificationsList,
              'salesPropertyInfoName',
              'salesPropertyInfoValue'
            )
          : []),
        (res.materNo = '');
      res.price = productInfo.price;
      res.productId = productInfo.productid;
      res.productName = productInfo.skuname;
      res.productPictUrl = productInfo.defaultimage;
      res.productSkuCode = productInfo.skucode;
      res.productSkuId = productInfo.skuid;
      res.quantity = productInfo.quantity;
      res.salesTaxNo = rateInfo.data.taxRateCode;
      res.salesTaxRate = parseFloat(rateInfo.data.taxRate);
      res.sinoProtocol = '';
      res.skuOptions = productInfo.specifications;
      res.supplierCompany = productInfo.suppliercompanyname;
      res.supplierCompanyId = productInfo.suppliercompanyid;
      res.tax = '';
      return res;
    },
    getActive() {
      if (this.productDetail.attrArray.length > 0) {
        for (let i = 0; i < this.productDetail.attrArray.length; i++) {
          this.activeIndex.push(i);
        }
      }
    },
    showToolTips(item1) {
      /* if (validateStrLen(item1) > 20) {
        this.disabled = false;
      } */
    },
    hideToolTips() {
      this.disabled = true;
    },

    addQuantityItem(arr, randomId) {
      arr.map(item => {
        item.randomId = randomId;
      });

      return arr;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/css/theme.scss';
.product-detail-floor-2-container {
  width: 100%;
  margin-top: 30px;
  .product-detail-floor-2-title {
    width: 1200px;
    height: 60px;
    margin: 0 auto;
    display: flex;
    flex-direction: row;
    /*background: #F1F1F1;*/
    /*font-size: 18px;*/
    /*font-family: MicrosoftYaHei;*/
    /*line-height: 60px;*/
    /*padding-left: 60px;*/
    /*margin: 0 auto;*/
    /*margin-bottom: 10px;*/
    .product-detail-floor-2-text {
      border-left: 1px solid #d9d9d9;
      border-top: 2px solid #2587ff;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      /*line-height: 21px;*/
      /* identical to box height */

      display: flex;
      align-items: center;
      justify-content: center;
      height: 44px;
      width: 120px;

      /* 蓝色/主色-蓝 2587FF */

      color: #2587ff;
    }
    .product-detail-floor-2-txt {
      width: 1080px;
      height: 44px;
      border-top: 1px solid #d9d9d9;
      border-right: 1px solid #d9d9d9;
      border-bottom: 1px solid #d9d9d9;
      background: #f5f5f5;
    }
  }
  .product-detail-floor-2-content {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: flex-start;
    /*align-items: center;*/
    .product-detail-left {
      width: 220px;
      .product-detail-left-title {
        width: 220px;
        height: 40px;
        background: #bddbff;
        font-size: 14px;

        font-weight: bold;
        color: #ffffff;
        line-height: 40px;
        padding-left: 10px;
        padding-right: 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .product-detail-left-title-name {
          display: flex;
          justify-content: center;
          align-items: center;

          font-style: normal;
          font-weight: normal;
          font-size: 14px;
          line-height: 21px;

          color: #333333;
        }
        .product-detail-left-title-tag {
          width: 64px;
          height: 24px;
          border: 1px solid #333333;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;

          font-style: normal;
          font-weight: normal;
          font-size: 12px;
          line-height: 18px;

          display: flex;
          align-items: center;
          text-align: right;

          color: #333333;
          &:hover {
            color: #2587ff;
            background: #ffffff;
            border: 1px solid #2587ff;
          }
        }
      }
      .product-detail-collapse {
        width: 220px;
        max-height: 555px;

        .product-detail-attr-title {
          width: 100%;
          background: #f1f1f1;
          /*display: flex;*/
          /*justify-content: space-between;*/
          align-items: center;
          flex-direction: column;
          .product-detail-attr-key {
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
            .product-detail-attr-key-val {
              font-size: 14px;

              color: #333333;
              display: flex;
              align-items: center;
              margin-left: 10px;
            }
            .product-detail-attr-up {
              display: flex;
              justify-content: center;
              align-items: center;
              margin-right: 10px;
            }
          }
          .product-detail-attr-val {
            width: 100%;
            background: #ffffff;
            padding-left: 10px;
            /*border-bottom: 1px solid #e2e2e2;*/
            border-left: 1px solid #e2e2e2;
            border-right: 1px solid #e2e2e2;
            padding-bottom: 5px;
          }
          ::v-deep .el-checkbox {
            margin-right: 20px;
            max-width: 182px;
            min-width: 75px;
          }
          ::v-deep .el-collapse-item__content {
            padding-bottom: 0px;
          }
          ::v-deep .el-collapse-item__header {
            background: #f4f7ff;
            font-size: 14px;
            padding-left: 10px;
            height: 30px;
            /*border-top: 1px solid #e2e2e2;*/
            border-left: 1px solid #e2e2e2;
            border-right: 1px solid #e2e2e2;
          }
          ::v-deep .el-checkbox__label {
            display: inline-block;
            vertical-align: bottom;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            max-width: 182px;
            /*min-width: 50px;*/
          }
          ::v-deep .el-collapse {
            max-height: 555px;
            overflow-y: auto;
          }
          ::v-deep .el-tooltip {
            &:hover {
              color: #2587ff;
            }
          }
          .product-detail-more {
            font-size: 14px;

            color: #2587ff;
            display: flex;
            justify-content: center;
            align-items: center;
            padding-top: 10px;
            padding-bottom: 10px;
            cursor: pointer;
            .up-arrow {
              width: 12px;
              height: 10px;
              margin-left: 4px;
            }
          }
          .product-detail-less {
            font-size: 14px;

            color: #2587ff;
            display: flex;
            justify-content: center;
            padding-top: 10px;
            padding-bottom: 10px;
            cursor: pointer;
            align-items: center;
            .down-arrow {
              width: 10px;
              height: 8px;
              margin-left: 4px;
            }
          }
        }
      }
    }
    .product-detail-right {
      width: 970px;
      display: flex;
      margin-left: 10px;
      /*justify-content: center;*/
      /*align-items: center;*/
      flex-direction: column;
      .product-detail-search {
        width: 500px;
        display: flex;
        flex-direction: row;
        ::v-deep input.el-input__inner {
          border-radius: 0;
          border: 1px solid $main-col;
        }
        ::v-deep .el-input {
          width: 310px;
        }
        .product-detail-search-btn {
          background: #ffffff;
          font-size: 14px;

          color: #2587ff;
          width: 100px;
          height: 40px;
          /*background: #FFA900;*/
          border-top: 1px solid $main-col;
          border-bottom: 1px solid $main-col;
          border-right: 1px solid $main-col;
          text-align: center;
          line-height: 40px;
          &:hover {
            background: #e8efff;
            // border-top: 1px solid $main-col;
            // border-bottom: 1px solid $main-col;
            // border-right: 1px solid $main-col;
          }
        }
        .product-detail-floor-2-total {
          font-style: normal;
          font-weight: normal;
          font-size: 14px;
          line-height: 21px;
          /* identical to box height */
          min-width: 52px;
          display: flex;
          align-items: center;
          /*text-align: right;*/

          color: #999999;
          margin-left: 9px;
        }
      }
      .product-detail-floor-2-table {
        width: 100%;
        ::v-deep .el-table__header-wrapper {
          border: 1px solid #d9d9d9;
        }
        ::v-deep .el-table__header tr,
        .el-table__header th {
          height: 40px;
        }
        ::v-deep .el-table td .cell {
          height: 110px;
          display: flex;
          justify-content: flex-start;
          flex-flow: column;
        }
        .el-table-btn {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 120px;
          height: 32px;
          background: #ffffff;
          font-size: 14px;
          color: #2587ff;
          margin-bottom: 10px;
          cursor: pointer;
          border: 1px solid #2587ff;
          &:hover {
            background: #126edf;
            color: #ffffff;
          }
        }
        .el-table-collect-btn {
          /*display: flex;*/
          /*justify-content: center;*/
          /*align-items: center;*/
          /*width: 120px;*/
          /*height: 30px;*/
          font-size: 14px;
          color: #333333;
          cursor: pointer;
          &:hover {
            color: $main-col;
            border-bottom: 1px solid $main-col;
          }
        }
        .order-list-key {
          font-size: 14px;
          color: #666666;
          ::v-deep.el-table__empty-text {
            line-height: 0;
          }
        }
        ::v-deep.el-table__empty-text {
          /*line-height: 14px;*/
        }
      }
      .product-detail-floor-2-pagination {
        margin-top: 20px;
        display: flex;
        justify-content: flex-end;
        align-items: center;
      }
    }
  }
  .move_dot {
    position: fixed;
    z-index: 100;
    top: 0;
    height: 20px;
    width: 20px;
    border-radius: 50%;

    img {
      animation: 0.88s mymove ease-in-out;
      -webkit-animation: 0.88s mymove ease-in-out;
      width: 60px;
      height: 60px;
      border-radius: 50%;
    }
    @keyframes mymove {
      0% {
        transform: scale(1.2);
      }
      25% {
        transform: scale(0.8);
      }
      50% {
        transform: scale(0.6);
      }
      75% {
        transform: scale(0.4);
      }
      100% {
        transform: scale(0.1);
      }
    }

    @-webkit-keyframes mymove {
      0% {
        transform: scale(1.2);
      }
      25% {
        transform: scale(0.8);
      }
      50% {
        transform: scale(0.6);
      }
      75% {
        transform: scale(0.4);
      }
      100% {
        transform: scale(0.1);
      }
    }
  }
}
</style>
